export default __webpack_public_path__ + "static/media/template.fc9053cc.png";